import Image from 'next/image';

const SolutionMobileLogosAnimation = () => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const logoList1 = [
    {
      no: 1,
      logo: '원진치과의원',
      w: 146,
      h: 28
    },
    {
      no: 2,
      logo: '솔동물',
      w: 159
    },
    {
      no: 3,
      logo: '하루플란트',
      w: 164,
      h: 20
    },
    {
      no: 4,
      logo: '라프린',
      w: 116
    },
    {
      no: 5,
      logo: '예스미르치과',
      w: 147
    },
    {
      no: 6,
      logo: 'madeyoung',
      w: 146
    },
    {
      no: 7,
      logo: '연세굿데이치과',
      w: 151
    }
  ];
  const logoList2 = [
    {
      no: 1,
      logo: '내이튼치과',
      w: 133,
      h: 26
    },
    {
      no: 2,
      logo: '연세세브란스치과',
      w: 152,
      h: 32
    },
    {
      no: 3,
      logo: '수지미래산부인과',
      w: 138
    },
    {
      no: 4,
      logo: '이하루치과',
      w: 110
    },
    {
      no: 5,
      logo: 'vsline',
      w: 101,
      h: 32
    },
    {
      no: 6,
      logo: '오라클치과',
      w: 157
    },
    {
      no: 7,
      logo: '시카고치과',
      w: 171
    }
  ];

  const logoList = (logo) => {
    return Array(10).fill(logo).flat();
  };
  return (
    <div className="w-full max-w-[768px] md:max-w-[1440px] px-5 md:px-[64px] w-full mt-[50px] md:mt-[65px] mb-[40px] flex flex-col items-start justify-center gap-[20px] overflow-hidden opacity-70">
      <div className="flex items-center justify-center gap-[20px] animate-logo-marquee">
        {logoList(logoList1).map((item, index) => {
          return <Image key={`client-logo1-${index}`} src={`${baseImageUrl}/home/client-logo1-0${item.no}.png`} alt={item.logo} width={item.w} height={item.h || 30} />;
        })}
      </div>
      <div className="flex items-center justify-center gap-[20px] animate-logo-marquee">
        {logoList(logoList2).map((item, index) => {
          return <Image key={`client-logo2-${index}`} src={`${baseImageUrl}/home/client-logo2-0${item.no}.png`} alt={item.logo} width={item.w} height={item.h || 30} className="h-auto" />;
        })}
      </div>
    </div>
  );
};

export default SolutionMobileLogosAnimation;
